import React, { Component } from 'react'
import Select from 'react-select'

class MenuSKUFilter extends Component {
    constructor() {
        super()
        this.state = {
            StatusList:[ {"label":"MAPPED SKUs","value":"1"},{"label":"NOT MAPPED SKUs","value":"0"}, {"label":"ALL","value":"ALL"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }
    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.StatusList}
                placeholder="Select SKU Filter"
                onChange={(e) => { (e) ? this.props.skuFilterChange(e) : this.props.skuFilterChange([])}}
                />
            </div>
        )
    }
}

export default MenuSKUFilter


// WEBPACK FOOTER //
// ./src/common/DropDowns/MenuSKUFilter.js